export const CARD_CLICK = 'CARD_CLICK';
export const CARD_MATCH = 'CARD_MATCH';
export const CARD_RESET = 'CARD_RESET';
export const GAME_START = 'GAME_START';
export const GAME_RESET = 'GAME_RESET';
export const GAME_WIN = 'GAME_WIN';
export const GAME_TIME = 'GAME_TIME';
